import { render, staticRenderFns } from "./recording.vue?vue&type=template&id=350fbca0&scoped=true"
import script from "./recording.vue?vue&type=script&lang=js"
export * from "./recording.vue?vue&type=script&lang=js"
import style0 from "./recording.vue?vue&type=style&index=0&id=350fbca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350fbca0",
  null
  
)

export default component.exports